import type { GoodsReceipt } from "@/graphql/codegen/graphql"
import { useGoodsReceiptActions } from "@/screens/WarehouseReceiving/hooks/useGoodsReceiptActions"
import type { GoodsReceiptActionState } from "@/screens/WarehouseReceiving/types"

interface UseCheckedInGoodsReceiptActionsProps {
  goodsReceipt?: GoodsReceipt | null
  onRefetch?: () => void
}

interface UseCheckedInGoodsReceiptActionsReturn {
  actionState: GoodsReceiptActionState
  handleDialogClose: () => void
  handleFormDialogSubmit: () => void
  handleEditGoodsReceipt: (goodsReceipt: GoodsReceipt) => void
  handleUpload: () => void
}

export const useCheckedInGoodsReceiptActions = ({
  goodsReceipt,
  onRefetch,
}: UseCheckedInGoodsReceiptActionsProps): UseCheckedInGoodsReceiptActionsReturn => {
  const { actionState, handleDialogClose, handleFormDialogSubmit, handleEditGoodsReceipt, handleUploadFiles } =
    useGoodsReceiptActions({
      goodsReceipt,
      onRefetch,
    })

  return {
    actionState,
    handleDialogClose,
    handleFormDialogSubmit,
    handleEditGoodsReceipt,
    handleUpload: handleUploadFiles,
  }
}
